import React from 'react';

export interface Category {
  id: string;
  name: string;
  icon?: React.ReactNode;
}

interface CategorySelectorProps {
  categories: Category[];
  selectedCategory: string;
  onCategoryChange: (categoryId: string) => void;
  className?: string;
}

const CategorySelector: React.FC<CategorySelectorProps> = ({
  categories,
  selectedCategory,
  onCategoryChange,
  className = '',
}) => {
  return (
    <div className={`category-filter-wrapper ${className}`}>
      <div className='category-filter-pills'>
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`category-pill ${
              selectedCategory === category.id ? 'active' : ''
            }`}
            aria-pressed={selectedCategory === category.id}
            aria-label={`Filter by ${category.name}`}
          >
            {category.icon && <span className='category-pill-icon'>{category.icon}</span>}
            <span className='category-pill-text'>{category.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategorySelector;
